export default __webpack_public_path__ + "static/media/zero-shot.660805f0.png";